<!--数据卡片-->
<template>
  <div class="score-card">
    <div class="tit">{{data.title}}</div>
    <div v-if="type==1 || type == 3" class="cnt score-card-up">{{data.num}}</div>
    <div v-else-if="type==2" class="cnt ranking"><span class="txt">第</span><span
        class="score-card-up num">{{data.num}}</span><span class="txt">名</span></div>
    <div v-if="type==1" class="diff"><span class="diff-tit">{{data.desc?data.desc:'比昨日'}}</span>&nbsp;<span :class="{'score-card-down':data.type==0,'score-card-fair':data.type==1,'score-card-up':data.type==2}" >{{data.diff}}</span>
    </div>
  </div>
</template>

<script>
    export default {
        components: {},
        props: {
            // 样式类型
            type: {
                type: Number,
                default: 0
            },
            // 数据
            data: {
                type: Object,
                default: () => {
                    return {
                        title: '',
                        num: '',
                        type: 1,
                        desc: '',
                        diff: ''
                    }
                }
            }

        },
        data () {
            return {

            }
        },
        computed: {

        },
        methods: {

        },
        mounted () {

        }

    }
</script>

<style scoped lang="less">
  .score-card {
    width: 176px;
    height: 118px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    &-up {
      color: rgba(54, 179, 116, 1);
       font-family:PingFangSC-Regular,PingFang SC;
       -webkit-font-smoothing: antialiased;
        font-weight: 700;
    }

    &-down {
      color: #FF4D4D;
    }

    &-fair {
      color: #2283E6;
    }

    .tit {
      font-size: 12px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 12px;
    }

    .cnt {
      margin-top: 8px;
      margin-bottom: 9px;
      font-size: 32px;
      font-weight: bold;
      line-height: 32px;

    }

    .ranking {
      .txt {
        font-size: 12px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 12px;
      }

      .num {
        font-size: 32px;
        font-family: DIN-Bold, DIN;
        font-weight: bold;
        color: rgba(54, 179, 116, 1);
        line-height: 32px;
        margin-left: 3px;
        margin-right: 3px;
      }
    }

    .diff {
      display: flex;
      align-items: center;

      &-tit {
        font-size: 12px;

        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 12px;
      }

    }
  }
</style>
